<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Accessories</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (replacementFilterSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Replacement Filter:</span>
              <select class="halfWidthInputField" #replacementFilterInput
                [class.invalidConfigurationSelection]="isInvalidSelection(replacementFilterSelection.Name)"
                (change)="selectionChanged(replacementFilterSelection, replacementFilterInput.value)"
                [value]="replacementFilterSelection.Value.toString()">
                @for (allowable of replacementFilterSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="replacementFilterSelection.Value && replacementFilterSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (thermostatSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Thermostat:</span>
              <select class="halfWidthInputField" #thermostatInput
                [class.invalidConfigurationSelection]="isInvalidSelection(thermostatSelection.Name)"
                (change)="selectionChanged(thermostatSelection, thermostatInput.value)"
                [value]="thermostatSelection.Value.toString()">
                @for (allowable of thermostatSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="thermostatSelection.Value && thermostatSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (controlsSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Controls:</span>
              <select class="halfWidthInputField" #controlsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(controlsSelection.Name)"
                (change)="selectionChanged(controlsSelection, controlsInput.value)"
                [value]="controlsSelection.Value.toString()">
                @for (allowable of controlsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="controlsSelection.Value && controlsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (stackCabinetStandSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Vertical Stack Cabinet Stand:</span>
              <select class="halfWidthInputField" #stackCabinetStandInput
                [class.invalidConfigurationSelection]="isInvalidSelection(stackCabinetStandSelection.Name)"
                (change)="selectionChanged(stackCabinetStandSelection, stackCabinetStandInput.value)"
                [value]="stackCabinetStandSelection.Value.toString()">
                @for (allowable of stackCabinetStandSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="stackCabinetStandSelection.Value && stackCabinetStandSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (heightSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Height:</span>
              <select class="halfWidthInputField" #heightInput
                [class.invalidConfigurationSelection]="isInvalidSelection(heightSelection.Name)"
                (change)="selectionChanged(heightSelection, heightInput.value)"
                [value]="heightSelection.Value.toString()">
                @for (allowable of heightSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="heightSelection.Value && heightSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (isoPadSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">ISO Pad:</span>
              <select class="halfWidthInputField" #isoPadInput
                [class.invalidConfigurationSelection]="isInvalidSelection(isoPadSelection.Name)"
                (change)="selectionChanged(isoPadSelection, isoPadInput.value)"
                [value]="isoPadSelection.Value.toString()">
                @for (allowable of isoPadSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="isoPadSelection.Value && isoPadSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (stackKitsSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Vertical Stack Kits:</span>
              <select class="halfWidthInputField" #verticalStackKitsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(stackKitsSelection.Name)"
                (change)="selectionChanged(stackKitsSelection, verticalStackKitsInput.value)"
                [value]="stackKitsSelection.Value.toString()">
                @for (allowable of stackKitsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="stackKitsSelection.Value && stackKitsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (stackAccessoriesSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Vertical Stack Accessories:</span>
              <select class="halfWidthInputField" #stackAccessoriesInput
                [class.invalidConfigurationSelection]="isInvalidSelection(stackAccessoriesSelection.Name)"
                (change)="selectionChanged(stackAccessoriesSelection, stackAccessoriesInput.value)"
                [value]="stackAccessoriesSelection.Value.toString()">
                @for (allowable of stackAccessoriesSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="stackAccessoriesSelection.Value && stackAccessoriesSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (stackBallValveAssembliesSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Ball Valve Assemblies:</span>
              <select class="halfWidthInputField" #ballValveAssembliesInput
                [class.invalidConfigurationSelection]="isInvalidSelection(stackBallValveAssembliesSelection.Name)"
                (change)="selectionChanged(stackBallValveAssembliesSelection, ballValveAssembliesInput.value)"
                [value]="stackBallValveAssembliesSelection.Value.toString()">
                @for (allowable of stackBallValveAssembliesSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="stackBallValveAssembliesSelection.Value && stackBallValveAssembliesSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (stackReturnPanelSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Return Air Panel:</span>
              <select class="halfWidthInputField" #returnAirPanelInput
                [class.invalidConfigurationSelection]="isInvalidSelection(stackReturnPanelSelection.Name)"
                (change)="selectionChanged(stackReturnPanelSelection, returnAirPanelInput.value)"
                [value]="stackReturnPanelSelection.Value.toString()">
                @for (allowable of stackReturnPanelSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="stackReturnPanelSelection.Value && stackReturnPanelSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (hoseKitsSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Hose Kits:</span>
              <select class="halfWidthInputField" #hoseKitsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(hoseKitsSelection.Name)"
                (change)="selectionChanged(hoseKitsSelection, hoseKitsInput.value)"
                [value]="hoseKitsSelection.Value.toString()">
                @for (allowable of hoseKitsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="hoseKitsSelection.Value && hoseKitsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (returnPanelFinishSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Return Panel Finish:</span>
              <select class="halfWidthInputField" #returnPanelFinishInput
                [class.invalidConfigurationSelection]="isInvalidSelection(returnPanelFinishSelection.Name)"
                (change)="selectionChanged(returnPanelFinishSelection, returnPanelFinishInput.value)"
                [value]="returnPanelFinishSelection.Value.toString()">
                @for (allowable of returnPanelFinishSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="returnPanelFinishSelection.Value && returnPanelFinishSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (returnPanelTypeSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Return Panel Type:</span>
              <select class="halfWidthInputField" #returnPanelTypeInput
                [class.invalidConfigurationSelection]="isInvalidSelection(returnPanelTypeSelection.Name)"
                (change)="selectionChanged(returnPanelTypeSelection, returnPanelTypeInput.value)"
                [value]="returnPanelTypeSelection.Value.toString()">
                @for (allowable of returnPanelTypeSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="returnPanelTypeSelection.Value && returnPanelTypeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (stackSupplyAirGrilleSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Supply Air Grille:</span>
              <select class="halfWidthInputField" #supplyAirGrilleInput
                [class.invalidConfigurationSelection]="isInvalidSelection(stackSupplyAirGrilleSelection.Name)"
                (change)="selectionChanged(stackSupplyAirGrilleSelection, supplyAirGrilleInput.value)"
                [value]="stackSupplyAirGrilleSelection.Value.toString()">
                @for (allowable of stackSupplyAirGrilleSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="stackSupplyAirGrilleSelection.Value && stackSupplyAirGrilleSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (supplyGrilleFinishSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Supply Grille Finish:</span>
              <select class="halfWidthInputField" #supplyGrilleFinishInput
                [class.invalidConfigurationSelection]="isInvalidSelection(supplyGrilleFinishSelection.Name)"
                (change)="selectionChanged(supplyGrilleFinishSelection, supplyGrilleFinishInput.value)"
                [value]="supplyGrilleFinishSelection.Value.toString()">
                @for (allowable of supplyGrilleFinishSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="supplyGrilleFinishSelection.Value && supplyGrilleFinishSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (supplyGrilleDimensionsSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Supply Grille Dimensions:</span>
              <select class="halfWidthInputField" #supplyGrilleDimensionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(supplyGrilleDimensionsSelection.Name)"
                (change)="selectionChanged(supplyGrilleDimensionsSelection, supplyGrilleDimensionsInput.value)"
                [value]="supplyGrilleDimensionsSelection.Value.toString()">
                @for (allowable of supplyGrilleDimensionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="supplyGrilleDimensionsSelection.Value && supplyGrilleDimensionsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
